import React from 'react';
import { Link } from 'react-router-dom';

const ServiceOffer = () => {
    return (
        <section>
            <div className="infocolors-grid-3cols infocolors-tp-grid-2cols infocolors-tp-stretch-last-item" data-stagger-appear="fade-up" data-stagger-unload="fade-up">
                <div className="infocolors-block stg-aspect-square stg-vertical-space-between">
                    <h5>More than just visuals<span className="infocolors-accent">.</span></h5>
                    <p>We build emotional connections that create loyal brand advocates.</p>
                </div>
                <div className="infocolors-block stg-aspect-square stg-vertical-space-between">
                    <h5>Beyond just a logo design<span className="infocolors-accent">.</span></h5>
                    <p>Beyond just designing a logo, we craft a story that captures hearts and minds.</p>
                </div>
                <div className="infocolors-masked-block infocolors-grid-more-masked">
                    <div className="infocolors-block stg-aspect-square stg-vertical-space-between is-accented infocolors-masked-media">
                        <h5>A brand isn't just a name<span className="infocolors-accent">.</span></h5>
                        <p className="infocolors-large-text">It's a movement. 👉 Let infocolors ignite it.</p>
                    </div>
                    <div className="infocolors-masked-content at-bottom-right">
                        <span className="infocolors-square-button is-secondary">
                            <span className="infocolors-icon infocolors-icon-explore"></span>
                        </span>
                    </div>
                    <Link to="/contact"></Link>
                </div>
            </div>
        </section>
    );
};

export default ServiceOffer;
